export default "<router-outlet></router-outlet>\n<span [hidden]=\"true\">{{appVersion}}</span>\n"